export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

type ToastActionType = typeof SHOW_TOAST | typeof HIDE_TOAST;

export type ToastType = {
  show: boolean;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  interval?: number;
};
const initialState: ToastType = {
  show: false,
  type: 'warning',
  message: '',
  interval: 0,
};

const toastReducer = (
  state = initialState,
  action: {
    type: ToastActionType;
    payload: Omit<ToastType, 'show'>;
  },
): ToastType => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...action.payload,
        show: true,
      };
    case HIDE_TOAST:
      return {
        ...state,
        show: false,
      };
    default:
      return state;
  }
};

export default toastReducer;
